import * as Actions from '../actions/auth'
import authService from '@/services/auth.service'

const state = {
    accessToken: localStorage.getItem('accessToken') || '',
    refreshToken: localStorage.getItem('refreshToken') || '',
    clientToken: localStorage.getItem('clientToken') || '',
    tokenExtensions: JSON.parse(localStorage.getItem('tokenExtensions')) || '',
    authStatus: '',
    tokenType: localStorage.getItem('tokenType') || '',
    forgotPasswordStatus: '',
    changePasswordStatus: '',
    termsAndConditionsAcceptanceRequired: JSON.parse(localStorage.getItem('termsAndConditionsAcceptanceRequired')) || false,
    isAuthenticated: JSON.parse(localStorage.getItem('isAuthenticated')) || false,
    validateSuscriptionStatus:''
}

const getters = {
    isAuthenticated: state => state.isAuthenticated,
    authStatus: state => state.authStatus,
    tokenExtensions: state => state.tokenExtensions,
    accessToken: (state) => state.accessToken,
    tokenType: (state) => state.tokenType,
    refreshToken: state => state.refreshToken,
    changePasswordStatus: state => state.changePasswordStatus

}

const actions = {
    [Actions.AUTH_REQUEST]: ({ commit }, user) => {
        return new Promise((resolve, reject) => {
            commit(Actions.AUTH_REQUEST)
            authService.getInternalToken(user)
                .then(resp => {
                    localStorage.setItem('accessToken', resp.accessToken)
                    localStorage.setItem('refreshToken', resp.refreshToken)
                    localStorage.setItem('tokenType', resp.tokenType)
                    localStorage.setItem('tokenExtensions', JSON.stringify(resp.extensions))

                    commit(Actions.AUTH_SET_ACCESS_TOKEN, resp)

                    if (resp.termsAndConditionsAcceptanceRequired) {
                        localStorage.setItem('termsAndConditionsAcceptanceRequired', true)
                        commit(Actions.TERMS_AND_CONDITIONS_REQUIRED, resp)
                    }
                    resolve(resp)
                })
                .catch(err => {
                    commit(Actions.AUTH_ERROR, err)
                    localStorage.removeItem('accessToken')
                    localStorage.removeItem('refreshToken')
                    localStorage.removeItem('tokenExtensions')
                    reject(err)
                })
        })
    },
    [Actions.VALIDATE_TOKEN]: ({ commit }, validation) => {
        return new Promise((resolve, reject) => {
            commit(Actions.VALIDATE_TOKEN)
            authService.validateSuscription(validation)
                .then(resp => {
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    [Actions.AUTH_SUCCESS]: ({ commit, payload }) => {
        commit(Actions.AUTH_SUCCESS, payload)
    },
    [Actions.AUTH_LOGOUT]: ({ commit }) => {
        return new Promise(resolve => {
            commit(Actions.AUTH_LOGOUT)
            localStorage.removeItem('accessToken')
            localStorage.removeItem('refreshToken')
            localStorage.removeItem('tokenExtensions')
            localStorage.removeItem('isRcmUser')
            localStorage.removeItem('filters')
            resolve()
        })
    },
    [Actions.CLIENT_TOKEN_REQUEST]: ({ commit }) => {
        return new Promise((resolve, reject) => {
            authService.getClientToken()
                .then(resp => {
                    localStorage.setItem('clientToken', resp.accessToken)
                    commit(Actions.CLIENT_TOKEN_SUCCESS, resp)
                    resolve(resp)
                })
                .catch(err => {
                    commit(Actions.CLIENT_TOKEN_ERROR, err)
                    localStorage.removeItem('clientToken')
                    reject(err)
                })
        })
    },
    [Actions.FORGOT_PASSWORD_REQUEST]: ({ commit }, email) => {
        return new Promise((resolve, reject) => {
            commit(Actions.FORGOT_PASSWORD_REQUEST)
            authService.requestPasswordChange(email)
                .then(resp => {
                    commit(Actions.FORGOT_PASSWORD_SUCCESS, resp)
                    resolve(resp)
                })
                .catch(err => {
                    commit(Actions.FORGOT_PASSWORD_ERROR, err)
                    reject(err)
                })
        })
    },
    [Actions.CHANGE_PASSWORD_REQUEST]: ({ commit }, request) => {
        return new Promise((resolve, reject) => {

            commit(Actions.CHANGE_PASSWORD_REQUEST)
            authService.changePassword(request.password, request.token)
                .then(resp => {
                    commit(Actions.CHANGE_PASSWORD_SUCCESS, resp)
                    resolve(resp)
                })
                .catch(err => {
                    commit(Actions.CHANGE_PASSWORD_ERROR, err)
                    reject(err)
                })
        })
    },
}

const mutations = {
    [Actions.AUTH_REQUEST]: (state) => {
        state.authStatus = 'loading';
    },
    [Actions.AUTH_SUCCESS]: (state) => {
        localStorage.setItem('isAuthenticated', 'true')
        state.isAuthenticated = JSON.parse(localStorage.getItem('isAuthenticated')) || false
    },
    [Actions.AUTH_SET_ACCESS_TOKEN]: (state, parameters) => {
        state.accessToken = parameters.accessToken
        state.refreshToken = parameters.refreshToken
        state.tokenType = parameters.tokenType
        state.tokenExtensions = parameters.extensions
    },
    [Actions.TERMS_AND_CONDITIONS_REQUIRED]: (state) => {
        state.termsAndConditionsAcceptanceRequired = true
    },
    [Actions.AUTH_ERROR]: state => {
        state.authStatus = 'error'
    },
    [Actions.AUTH_LOGOUT]: state => {
        state.accessToken = ''
        state.refreshToken = ''
        state.tokenExtensions = ''
        state.termsAndConditionsAcceptanceRequired = false
        state.isAuthenticated = false
        localStorage.removeItem('clientToken')
        localStorage.removeItem('accessToken')
        localStorage.removeItem('refreshToken')
        localStorage.removeItem('tokenExtensions')
        localStorage.removeItem('termsAndConditionsAcceptanceRequired')
        localStorage.removeItem('isAuthenticated')
    },
    [Actions.CLIENT_TOKEN_SUCCESS]: (state, parameters) => {
        state.clientToken = parameters.accessToken
    },
    [Actions.CLIENT_TOKEN_ERROR]: state => {
        state.clientToken = ''
    },
    [Actions.FORGOT_PASSWORD_REQUEST]: (state) => {
        state.forgotPasswordStatus = 'loading'
    },
    [Actions.FORGOT_PASSWORD_SUCCESS]: (state) => {
        localStorage.removeItem('clientToken')
        state.clientToken = ''
        state.forgotPasswordStatus = 'success'
    },
    [Actions.FORGOT_PASSWORD_ERROR]: state => {
        localStorage.removeItem('clientToken')
        state.clientToken = ''
        state.forgotPasswordStatus = 'error'
    },
    [Actions.SET_TOKEN](state, parameters) {
        state.accessToken = parameters.accessToken;
        localStorage.setItem('accessToken',parameters.accessToken);
    },
    [Actions.SET_ACTUAL_URL](state, parameters) {
        state.currentUrl = parameters.currentUrl;
        localStorage.setItem('currentUrl',parameters.currentUrl);
    },
    [Actions.CHANGE_PASSWORD_REQUEST]: (state) => {
        state.changePasswordStatus = 'loading'
    },
    [Actions.CHANGE_PASSWORD_SUCCESS]: (state) => {
        state.changePasswordStatus = 'success'
    },
    [Actions.CHANGE_PASSWORD_ERROR]: state => {
        state.changePasswordStatus = 'error'
    },
    [Actions.RESET_CHANGE_PASSWORD_STATUS]: state => {
        state.changePasswordStatus = ''
    },
    [Actions.VALIDATE_TOKEN]: state => {
        state.validateSuscriptionStatus = 'loading'
    },
    [Actions.VALIDATE_TOKEN_SUCCESS]: state => {
        state.validateSuscriptionStatus = 'success'
    },
    [Actions.VALIDATE_TOKEN_ERROR]: state => {
        state.validateSuscriptionStatus = 'error'
    }
}

export default {
    actions,
    getters,
    mutations,
    state
}
